import { createSvgIcon, type SvgIconProps } from '@mui/material';
import palette from '../../../theme/palette';

const IconConsumptionElectricityBase = createSvgIcon(
  <path
    d="M7.03334 12.134L10.4833 8.00065H7.81667L8.3 4.21732L5.21667 8.66732H7.53334L7.03334 12.134ZM5.33334 14.6673L6 10.0007H2.66667L8.66667 1.33398H10L9.33334 6.66732H13.3333L6.66667 14.6673H5.33334Z"
    fill={palette.light.grey[600]}
  />,
  'IconConsumptionElectricity',
);

export function IconConsumptionElectricity(props: SvgIconProps) {
  return <IconConsumptionElectricityBase viewBox="0 0 16 16" {...props} />;
}
